import React from 'react';
import { makeStyles, Theme, createStyles, Box, Link } from '@material-ui/core';
import { BlackHeadings, LightGray } from '../../theme/colors';
import BaseTypography from '../Text/BaseTypography';
import { PORTAL_URL } from '../../constants/pathConsts';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      letterSpacing: '2px',
      marginTop: theme.spacing(3),
      left: '50%',
      transform: 'translateX(-50%)',
      [theme.breakpoints.up('sm')]: {
        zIndex: 1, // wihtout this text cannot be hoverable
        cursor: 'pointer',
        color: LightGray,
        '&:hover': {
          color: BlackHeadings,
        },
      },
      [theme.breakpoints.down('xs')]: {
        color: BlackHeadings,
        width: '100%',
        textAlign: 'center',
      },
    },
  }),
);
export const AuthScreenPortalBadge = () => {
  const classes = useStyles();

  return (
    <Box
      width={1}
      display="flex"
      justifyContent="center"
      zIndex={1}
      position="relative"
    >
      <Link
        href={`${PORTAL_URL}/?utm_medium=powered_by&utm_source=${encodeURIComponent(
          window.location.href,
        )}`}
        target="_blank"
        style={{ textDecoration: 'none' }}
      >
        <BaseTypography fontType="15Regular" className={classes.root}>
          Powered by Portal
        </BaseTypography>
      </Link>
    </Box>
  );
};
